import React from 'react';
import Icon from '../../../components/AppIcon';

const PrivacyInfoCard = () => {
  const privacyPoints = [
    {
      icon: 'Shield',
      title: 'No Account Required',
      description: 'Use the app without creating an account or sharing personal information'
    },
    {
      icon: 'Lock',
      title: 'Local Storage Only',
      description: 'All your data stays on your device and is never sent to external servers'
    },
    {
      icon: 'Eye',
      title: 'You Control Sharing',
      description: 'Choose when and what to share with your doctor through exports'
    },
    {
      icon: 'Trash2',
      title: 'Easy Data Deletion',
      description: 'Clear all your data anytime with a single tap'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="p-4 sm:p-5 bg-primary/5 border border-primary/20 rounded-lg">
        <div className="flex items-start gap-3 mb-4">
          <Icon name="ShieldCheck" size={24} color="var(--color-primary)" strokeWidth={2} />
          <div className="flex-1 min-w-0">
            <h3 className="text-base sm:text-lg font-semibold text-foreground mb-2">
              Your Privacy Matters
            </h3>
            <p className="text-sm sm:text-base text-muted-foreground">
              MyBodyToday is designed with privacy at its core. We believe your health data belongs to you.
            </p>
          </div>
        </div>
      </div>
      <div className="space-y-3">
        {privacyPoints?.map((point, index) => (
          <div 
            key={index}
            className="flex items-start gap-3 p-3 sm:p-4 rounded-lg bg-card border border-border"
          >
            <div className="flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-muted flex-shrink-0">
              <Icon name={point?.icon} size={18} color="var(--color-muted-foreground)" strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm sm:text-base font-semibold text-foreground mb-1">
                {point?.title}
              </h4>
              <p className="text-xs sm:text-sm text-muted-foreground">
                {point?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 sm:p-5 bg-muted/50 rounded-lg border border-border">
        <p className="text-xs sm:text-sm text-muted-foreground">
          <strong className="text-foreground">Last Updated:</strong> January 16, 2026
          <br />
          For detailed privacy information, please review our full privacy policy.
        </p>
      </div>
    </div>
  );
};

export default PrivacyInfoCard;